module.exports = __webpack_public_path__ + "img/renke-3.033ac463.png";